import { gql } from '@apollo/client';

export const query = gql`
  query ExchangeRateQuery {
    clearing {
      USDRUB: exchange(exchange: { from: { value: "1", currency: "USD" }, to: "RUB" }) {
        value
        currency {
          code
        }
      }
      RUBUSD: exchange(exchange: { from: { value: "1", currency: "RUB" }, to: "USD" }) {
        value
        currency {
          code
        }
      }
    }
  }
`;
